<template>
  <div class="page privacy px-2xl">
    <h1>MIS Privacy Policy</h1>
    <a
      target="_blank"
      href="https://www.mis-implants.com/upload/Info/Legal/mis-privacy-policy.pdf"
      >Please click here to view our privacy policy.</a
    >
  </div>
</template>

<script>
export default {};
</script>

<style lang="stylus" scoped>
.privacy
  min-height 30vh
  padding-top 10vh
  padding-bottom 10vh
</style>
